import { motion } from "framer-motion";
import { cn } from "@/lib/cn";

const SPRING = { type: "spring" as const, stiffness: 300, damping: 30 };

export function ToggleSwitch({
  enabled,
  onToggle,
  ariaLabel,
}: {
  enabled: boolean;
  onToggle: () => void;
  ariaLabel: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label={ariaLabel}
      onClick={onToggle}
      className={cn(
        "relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full",
        "transition-colors duration-200",
        enabled ? "bg-[var(--color-primary)]" : "bg-[var(--color-border)]",
      )}
    >
      <motion.span
        layout
        transition={SPRING}
        className={cn(
          "block h-5 w-5 rounded-full bg-white shadow-sm",
          enabled ? "ml-6" : "ml-1",
        )}
      />
    </button>
  );
}
